import { widgetSettings, choroplethWidgetSettings } from '@keen.io/widgets';

var createLegendSettings = function createLegendSettings(widgetType) {
  var settings = widgetType === 'choropleth' ? choroplethWidgetSettings : widgetSettings;
  var _settings$legend = settings.legend,
      enabled = _settings$legend.enabled,
      position = _settings$legend.position,
      alignment = _settings$legend.alignment,
      layout = _settings$legend.layout;
  return {
    legend: {
      enabled: enabled,
      position: position,
      alignment: alignment,
      layout: layout
    }
  };
};

export default createLegendSettings;